import { PrivateAvatar } from '../../shared/PrivateImage';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Typography, IconButton,Button} from '@mui/material';
import { Search as SearchIcon, ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import axios from 'axios';
import { ContextData } from '../../../context/Context';
import baseUrl from '../../../BaseURL';
import AddMemberDialog from '../Contents/Member/AddMemberDialog';
import ViewPopUserEdit from '../Contents/Member/ViewPopUserEdit';
import LoadingStatus from './LoadingStatus';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import VerifiedIcon from '@mui/icons-material/Verified';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import WalletRechargeDialog from '../Contents/RechargeUser/WalletRechargeDialog';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import DialogueAllmenbers from '../Contents/Member/DialogueAllmenbers';

/* import EditStudentPop from './PopDialogue/Student/EditStudentPop';
 */

const Members = (props) => {


  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [MemberData,setMemberData] = useState(null)
  const [CountData,setCountData] = useState(0)
  const [Amount,setAmount] = useState("")
  const [Balance,setBalance] = useState(0)
  const Navigate = useNavigate()



   const rowsPerPage = 6;
   const {logout,loggingOut,setLoader,accesstoken,Refresh,setRefresh,Person,RefreshAmount,} = useContext(ContextData)

     useEffect(()=>{setRefresh(!Refresh)},[])

  const isAdmin = ['100', '90'].includes(String(Person?.acc_level));
  const [fetchLimit, setFetchLimit] = useState(30);
  const [hasMore, setHasMore] = useState(false);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [memberError, setMemberError] = useState('');
  const [query, setQuery] = useState('');
  const [offset, setOffset] = useState(0);
  const [retry, setRetry] = useState(0);
  useEffect(() => {setOffset(0);setCurrentPage(1);}, [Refresh]);
  useEffect(() => {
    const timer = setTimeout(() => {setQuery(searchText.trim()); setOffset(0); setCurrentPage(1);}, 350);
    return () => clearTimeout(timer);
  }, [searchText]);
  useEffect(() => {
    if (!Person) return;
    const controller = new AbortController();
    setLoadingMembers(true); setMemberError('');
    const url = isAdmin ? `${baseUrl}/auth/get_member_datas_for_admin` : `${baseUrl}/auth/get_data_member_user/${Person.token}`;
    axios.get(url, {signal:controller.signal, withCredentials:true, headers:{authorization:`Bearer ${accesstoken}`},
      params:isAdmin ? {limit:fetchLimit, offset, search:query} : undefined
    }).then(({data}) => {
      if (controller.signal.aborted) return;
      const members = isAdmin ? data.members : data;
      setMemberData(previous => isAdmin && offset > 0 ? Array.from(new Map([...(previous || []), ...members].map(member => [member.token, member])).values()) : members);
      setHasMore(isAdmin && data.hasMore); setLoader(false);
    }).catch(error => {if(!controller.signal.aborted)setMemberError('Unable to load members. Please try again.');})
      .finally(() => {if(!controller.signal.aborted)setLoadingMembers(false);});
    return () => controller.abort();
  }, [Person, accesstoken, Refresh, isAdmin, fetchLimit, offset, query, retry, setLoader]);

  useEffect(()=>{

          // Fetches data from amount
          async function FetchAmountData(){
            //  setLoader(true)

          try {
            const response = await axios.get(`${baseUrl}/auth/get_amount/${Person.token}`,{
              withCredentials: true,
              headers: {
                'Accept' : 'application/json',
                'authorization': `Bearer ${accesstoken !== null && accesstoken}`
              }})


              setAmount(response.data[0].amount)


          } catch (err) {
             if(err) console.log(err.message)
            // setLoader(false)
          }


    }FetchAmountData()


  },[Refresh])


  useEffect(()=>{

    // Fetches data from amount
    async function FetchAmountData(){
      //  setLoader(true)

    try {
      const response = await axios.get(`${baseUrl}/auth/get_acoounts/${Person.token}`,{
        withCredentials: true,
        headers: {
          'Accept' : 'application/json',
          'authorization': `Bearer ${accesstoken !== null && accesstoken}`
        }})


        setBalance(response.data[0].balance_amount)


    } catch (err) {
       if(err) console.log(err.message)
      // setLoader(false)
    }


}FetchAmountData()


},[Refresh])


  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
  };


    const List =  Object.keys(MemberData !== null && MemberData).map(data=> MemberData[data])
    const filteredUsers = List.filter(user => {
    if (isAdmin) return true;
    const lowerCaseSearchText = searchText.toLowerCase().trim();
    let fullName = user.fname +" "+ user.lname
    return (

     ( fullName.toLowerCase().includes(lowerCaseSearchText) ) ||
      String(user.mobile || '').toLowerCase().includes(lowerCaseSearchText) ||
      String(user.country || '').toLowerCase().includes(lowerCaseSearchText) ||
      String(user.r_ID || '').toLowerCase().includes(lowerCaseSearchText) ||
      String(user.origin || '').toLowerCase().includes(lowerCaseSearchText)
    //  user.email.toLowerCase().includes(lowerCaseSearchText)
      // Add more fields for search if needed (e.g., state, phone number)
    );
  });

  const filteredMembers = useMemo(() => {

    return MemberData ? MemberData.filter(list => list.acc_status === 2 || list.acc_status === 1 || list.acc_status === 3) : [];

  }, [MemberData]);

  const filteredPendingMembers = useMemo(() => {
    return MemberData ? MemberData.filter(list => list.acc_status === 0) : [];
  }, [MemberData]);

  const count = filteredMembers.length;
  const PendingMembers = filteredPendingMembers.length


  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const indexOfLastUser = currentPage * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;
  const usersToShow = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const handleNextPage = () => {
    setCurrentPage(prevPage => prevPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage(prevPage => prevPage - 1);
  };

  const HanldeRemove = async (tokens) =>{


    try {
      const response = await axios.delete(`${baseUrl}/auth/remove_member/${tokens}`,{
        withCredentials: true,
        headers: {
          'Accept' : 'application/json',
          'authorization': `Bearer ${accesstoken !== null && accesstoken}`

        }})
        setRefresh(!Refresh)
       } catch (err) {
       if(err) console.log(err.message)
     //  setLoader(false)
       }



  }

  const HanldeRevoked = async (r_ID) =>{


    try {
      const response = await axios.put(`${baseUrl}/auth/revoked_approve_id_card/${r_ID}`,{
        withCredentials: true,
        headers: {
          'Accept' : 'application/json',
          'authorization': `Bearer ${accesstoken !== null && accesstoken}`

        }})

         toast.success(response.data.statusText)
         setRefresh(!Refresh)
       } catch (err) {
       if(err) console.log(err.message)
     //  setLoader(false)
       }



  }

  const RefreshPage = () =>{
    setRefresh(!Refresh)
  }
   const Logout = async () => {
     try { await logout(); } catch (error) { toast.error(error.message); }
   };

  return (

    <Container>
      {isAdmin && <div style={{display:'flex',gap:12,alignItems:'center',flexWrap:'wrap',marginBottom:16}}>
        <TextField select label="Members per fetch" value={fetchLimit} SelectProps={{native:true}} onChange={event=>{setFetchLimit(Number(event.target.value));setOffset(0);setCurrentPage(1);}}>
          {[30,60,100,200].map(size=><option key={size} value={size}>{size}</option>)}
        </TextField><Typography>{MemberData?.length || 0} members loaded</Typography>
      </div>}
      {memberError && <div role="alert">{memberError}<Button onClick={()=>setRetry(value=>value+1)}>Retry</Button></div>}
      {loadingMembers && <Typography role="status">Loading members…</Typography>}

      <div  className='flex justify-between items-center  mem-top-point-con'>

         {
          Person !== null && <>{Person.acc_level === "0" &&
         <div className='flex w-full justify-between hide-refrsh-logout-btns-con'>
         <Button onClick={RefreshPage} className='Hover-'  elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(0, 24, 69)', color:"white", margin:'9px 4px'}}  size="medium" variant="contained">
           Refresh Page
         </Button>

         <Button onClick={Logout} disabled={loggingOut} className='Hover-'  elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(0, 24, 69)', color:"white", margin:'9px 4px'}}  size="medium" variant="contained">
           Logout
         </Button>

         </div>
          }</>
         }
        <p className='font-extrabold mt-3'>Registered Members</p>
         {
           Person !== null && <>{(Person.acc_level === "100" || Person.acc_level === "90") &&  <DialogueAllmenbers  />  }</>
           }

        {
           Person !== null && <>{Person.acc_level === "100" ?

            <p><b>Approved members loaded:</b> {count}</p>
            :
            <p> {Person.acc_level === "0" && <><b>Total Submitted:</b> {PendingMembers}</>}</p>
            }</>
        }

          {
            Person !== null && Person.usertype === "user" &&
             <>
             {Amount !== null &&
             <p className='mt-3 border-spacing-2 text-4xl mb-2'> <span className='bg-slate-900  text-white p-1 rounded-md'><b>Credit:</b><span className='bg-white border-spacing-x-1 text-black whitespace-nowrap pl-1 pr-1' >{Amount}</span></span> </p>
              }

              {/* {Amount !== null &&
             <p className='mt-3 border-spacing-2 text-4xl mb-2 ml-2 mr-2'> <span className='bg-slate-900  text-white p-1 rounded-md'><b>Earnings:</b><span className='bg-white border-spacing-x-1 text-black whitespace-nowrap pl-1 pr-1' >{Balance.toLocaleString()}</span></span> </p>
              } */}

            <div className='add-btn-con-mmem'>
              <WalletRechargeDialog balance={Amount} />

              <AddMemberDialog from="user" />

            </div>


             </>
            }

      </div>

      <TextField
        label="Search"
        variant="outlined"
        value={searchText}
        onChange={handleSearchChange}
        InputProps={{
          endAdornment: (
            <IconButton>
              <SearchIcon />
            </IconButton>
          ),
        }}
        fullWidth
        margin="normal"
      />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>

            <TableRow sx={{background:"rgb(0, 24, 69)"}}>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>No.</TableCell>


              {
                Person !== null && <> {(Person.acc_level === "100" || Person.acc_level === "90")  &&
                <>
                 <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Avatar</TableCell>
                </>}
                </>
                }

              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Full Name</TableCell>
                {
                  Person !== null && <> {(Person.acc_level === "100" || Person.acc_level === "90") &&
                 <>

                 <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Age</TableCell>
                  <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Mobile</TableCell>
                  <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Origin</TableCell>
                  <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Country</TableCell>
                  {Person !== null && <> {Person.acc_level === "100" &&
                   <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Restrict</TableCell>

                  } </>
                  }

                  <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>NIN</TableCell>
                  <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Verified</TableCell>
                  <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Received IDCard</TableCell>
                  <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Revoked IDCard</TableCell>

                 </>

                  } </>
                }

              {Person !== null && <TableCell align='center' sx={{color:"white",fontWeight:"800"}}> {Person.acc_level === "100" ? "View/Edit" : "View"} </TableCell>

              }

              {Person !== null && <> {Person.acc_level === "0" &&
               <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Status</TableCell>

              } </>

              }

              {Person !== null && <> {Person.acc_level === "100" &&
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Remove Member</TableCell>} </>

              }

            </TableRow>
          </TableHead>
          <TableBody>
            {
              MemberData !== null && <>

            {usersToShow.map((user,index) => (
              <TableRow key={user.token}>
                <TableCell  align='center' sx={{whiteSpace:"nowrap"}}>{index + 1}</TableCell>

                    {
                      Person !== null && <> {(Person.acc_level === "100" || Person.acc_level === "90" )&&  <>
                         <TableCell>

                          <PrivateAvatar title={user.picture} sx={{boxShadow:'2px 2px 10px rgba(0,0,0,0.364)'}} alt={user.fname} src={`${baseUrl}/files/assets/MemberPictures/${user.picture}`} />

                          </TableCell>
                        </> } </>
                    }

                <TableCell  align='center' sx={{whiteSpace:"nowrap"}}>{user.fname} {user.lname}</TableCell>
                {
                  Person !== null && <> {(Person.acc_level === "100" || Person.acc_level === "90" )&&
                                <>

                 <TableCell  align='center' sx={{whiteSpace:"nowrap"}}>{user.age}</TableCell>
                <TableCell  align='center' sx={{whiteSpace:"nowrap"}}>{user.mobile}</TableCell>
                <TableCell  align='center' sx={{whiteSpace:"nowrap"}}>{user.origin}</TableCell>
                <TableCell  align='center' sx={{whiteSpace:"nowrap"}}>{user.country}</TableCell>
                                </>
                 } </>
                }

                {Person !== null && <> {Person.acc_level === "100" &&

               <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.acc_lock.toString() === "0" ?

               <Button className='Hover-' onClick={()=> HanldeRemove(user.st_tokens)} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(199, 1, 1)', margin:'9px 0px'}}  size="large" variant="contained">
                  Lock
                </Button>
                           :
                <Button className='Hover-' onClick={()=> HanldeRemove(user.st_tokens)} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(179, 103, 21)', margin:'9px 0px'}}  size="large" variant="contained">
                  Unlock
               </Button>
               }

               </TableCell>


              } </>

              }

                {
                Person !== null && <> {(Person.acc_level === "100" || Person.acc_level === "90") &&
                <>
                <TableCell  align='center' sx={{whiteSpace:"nowrap"}}>{user.nin}</TableCell>
                <TableCell  align='center' sx={{whiteSpace:"nowrap"}}>{user.acc_status ? 'Yes' : 'No'}</TableCell>
                <TableCell  align='center' sx={{whiteSpace:"nowrap"}}>{user.id_card_status === "0" ? 'No' : 'Yes'}</TableCell>
                <TableCell  align='center' sx={{whiteSpace:"nowrap"}}>

                <Button className='Hover-' onClick={()=> HanldeRevoked(user.r_ID)} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(99, 121, 51)', margin:'9px 0px'}}  size="large" variant="contained">
                  Revoke Card
                </Button>

                </TableCell>
                </>}
                </>
                }

                  <TableCell>
                   <ViewPopUserEdit
                    token={user.token}
                    pic={user.picture}
                    nin={user.ninFile}
                    ninId={user.nin}
                    r_ID={user.r_ID}

                   />
                  </TableCell>

                  <TableCell>
               {Person !== null && <> {Person.acc_level === "100" &&
              <Button className='Hover-' onClick={()=> HanldeRemove(user.token)} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(199, 1, 1)', margin:'9px 0px'}}  size="large" variant="contained">
              Remove
            </Button>
            } </>


               }

                {
                  Person !== null &&
                  <>
                  {Person.acc_level === "0" &&

                   <>

                   <span style={{display:'inline-flex',alignItems:'center',gap:6,fontWeight:700,color:Number(user.acc_status)===4?'#b42318':Number(user.acc_status)===3?'#176345':'#665924'}}>
                     {({0:'Pending',1:'Awaiting verification',2:'Awaiting approval',3:'Approved',4:'Rejected'})[Number(user.acc_status)] || 'Processing'}
                     {Number(user.acc_status)===3&&<VerifiedIcon color="success"/>}
                     {Number(user.acc_status)===4&&<NoAccountsIcon color="error"/>}
                   </span>
                    </>



                  }

                  </>
                }

                  </TableCell>

              </TableRow>
            ))}
              </>
            }
            {
              MemberData === null && <p className=' w-full h-full flex justify-center items-center'>loading...</p>
            }
          </TableBody>
        </Table>
      </TableContainer>
      {isAdmin && hasMore && <Button disabled={loadingMembers || query !== searchText.trim()} onClick={()=>setOffset(MemberData?.length || 0)}>Fetch more members</Button>}
      {totalPages > 1 && (
        <div>
          {currentPage > 1 && (
            <IconButton onClick={handlePrevPage}>
              <ArrowBackIcon />
            </IconButton>
          )}
          <span>Page {currentPage} of {totalPages}</span>
          {currentPage < totalPages && (
            <IconButton onClick={handleNextPage}>
              <ArrowForwardIcon />
            </IconButton>
          )}
        </div>
      )}
    </Container>
  );
};

export default Members;
